<template>
  <WrapGrads :agency="agency" :state="state" />
  <div
    class="slider-wrapper-top fixed flex left-8.5 right-8.5 top-8.5"
    style="z-index: 201"
  >
    <div
      class="menu cursor-pointer w-12.5"
      :class="{ unactive: !menuActive }"
      @click="toggleMenu"
    >
      <div class="menu-content">
        <transition name="menu-label" mode="out-in">
          <p v-if="!menuActive" class="uppercase font-medium fz-12 mb-3">
            {{ text.menu }}
          </p>
          <p v-else class="uppercase font-medium fz-12 mb-3">
            {{ text.close }}
          </p>
        </transition>

        <div class="h-5 relative w-full">
          <div
            class="absolute h-2px bg-white"
            :class="{
              'active-menu w-5 left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 rotate-45': menuActive,
              'w-full top-0 left-0': !menuActive,
            }"
          ></div>
          <div
            id="second-menu-strip"
            class="absolute h-2px bg-white"
            :class="{
              'active-menu w-5 left-1/2 bottom-1/2 transform -translate-x-1/2 translate-y-1/2 -rotate-45': menuActive,
              'w-1/2 bottom-0 left-0': !menuActive,
            }"
          ></div>
        </div>
      </div>
      <div class="menu-grad relative -top-32 left-0" style="z-index: -1">
        <div class="blue-b"></div>
        <div class="blue-s"></div>
        <div class="purple"></div>
        <div class="purple-s"></div>
      </div>
    </div>

    <div
      class="max-frai ml-19.5 relative z-70"
      :class="{ 'cursor-pointer': menuActive }"
      @click="setRoute('main')"
    >
      <img src="@/assets/images/max-frai.svg" class="w-full" alt="" />
      <p
        class="uppercase inter font-bold mt-4 fz-10"
        style="color: #ff2e53; letter-spacing: 1rem; line-height: 1"
      >
        {{ text.AGENCY }}
      </p>
    </div>

    <div
      @click="toggleContacts"
      class="connect ml-auto cursor-pointer relative z-70"
    >
      <div class="connect-content flex justify-end items-center">
        <p class="uppercase font-semibold fz-15 mr-4">{{ text.contact }}</p>
        <div class="plus w-12.5 h-12.5 rounded-full relative">
          <div
            class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-4 h-2px"
          ></div>
          <div
            class="absolute top-1/2 left-1/2 transform rotate-90 -translate-x-1/2 -translate-y-1/2 w-4 h-2px"
          ></div>
        </div>
      </div>

      <div class="connect-grad relative" style="z-index: -1">
        <div id="grad-1"></div>
        <div id="grad-2"></div>
        <div id="grad-3"></div>
      </div>
    </div>
  </div>
  <div v-if="main" class="slider-wrapper-left fixed bottom-8.5 left-8.5 top-37.5" style="z-index: 100;">
    <div class="relative w-10 h-full states" :class="'state-' + state">
      <div id="first-strip"></div>
      <div id="second-strip"></div>
      <div id="third-strip"></div>
      <div id="fourth-strip"></div>
      <div id="fifth-strip"></div>
      <div id="sixth-strip"></div>
      <div id="seventh-strip"></div>
      <div class="absolute left-0 h-px w-3/4 opacity-30 bottom-0"></div>
    </div>
  </div>
  <div
    v-if="main"
    class="slider-wrapper-right fixed bottom-8.5 right-8.5 top-37.5 z-50"
    style="z-index: 100;"
  >
    <div class="relative w-22.5 h-full">
      <div
        class="absolute right-0 transition-all h-px w-1/3 opacity-30 top-1.5"
      ></div>
      <div
        class="absolute right-0 transition-all h-3px w-1/6 opacity-60"
        style="top: 41.35%"
      ></div>
      <div
        class="absolute right-0 transition-all h-3px w-1/15 opacity-30"
        style="top: 43.695%"
      ></div>
      <div
        @click="$emit('prevSlide')"
        class="absolute flex bottom-2.5 right-0 cursor-pointer"
        style="background: transparent"
      >
        <div class="numbers flex mr-2 relative w-5">
          <transition name="numbers" v-for="item in 7" :key="item">
            <p
              v-if="state === item"
              class="fz-30 absolute"
              style="line-height: 0.78; background: transparent"
            >
              {{ item }}
            </p>
          </transition>
          <p
            class="fz-30 absolute first8 left-0"
            :class="state !== 8 ? 'inactive' : ''"
            style="background: transparent"
          >
            8
          </p>
          <transition name="second8">
            <p
              v-if="state === 8"
              class="fz-30 absolute left-0"
              style="line-height: 0.78; background: transparent"
            >
              8
            </p>
          </transition>
        </div>
        <div class="flex flex-col">
          <div>
            <p
              class="number fz-10 third8"
              :class="state !== 8 ? 'inactive' : ''"
            >
              8
            </p>
          </div>
          <div
            class="h-px w-15px mt-1"
            style="background: rgba(151, 163, 203, 0.6)"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="main"
    class="slider-wrapper-bottom fixed bottom-8.5 transform transition cursor-pointer z-50"
    style="left: 20.05%"
    @click="$emit('nextSlide')"
  >
    <svg
      width="14"
      class="transform transition duration-800"
      :class="state === 8 ? 'rotate-180' : ''"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 6L7 12L13 6" stroke-linejoin="round" />
      <path d="M6.99998 0V12" stroke-linejoin="round" />
    </svg>
    <p class="fz-10 font-medium uppercase mt-2.5" style="letter-spacing: 0.3em">
      {{ state !== 8 ? text.scroll : text.back }}
    </p>
  </div>
</template>

<script>
import WrapGrads from "./WrapGrads";
import {mapMutations, mapState} from "vuex";

export default {
  name: "wrappers",
  components: { WrapGrads },
  props: ["state"],
  data() {
    return {
      menuHover: null,
      agency: false,
    };
  },
  emits: ["prevSlide", "nextSlide"],
  methods: {
    ...mapMutations(['setRoute', 'toggleContacts', 'toggleMenu']),
    agencyGradsOn() {
      this.agency = true;
    },
    agencyGradsOff() {
      if (this.state === 8) {
        return;
      }
      this.agency = false;
    },
  },
  computed: {
    text() {
      return require("@/assets/text/fixWrappers/" + this.lang + ".json");
    },
    ...mapState(['lang', 'menuActive', 'page']),
    main(){
      return (this.page === 'main')
    }
  },
};
</script>

<style lang="scss" scoped>
.slider-wrapper-left {
  .states {
    div {
      position: absolute;
      left: 0;
      background: #97a3cb;
    }
  }
  .state-1 {
    div {
      transition: all 0.8s linear;
    }
    #first-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 0;
    }
    #second-strip {
      height: 1px;
      width: 100%;
      opacity: 0.3;
      top: 11.905%;
    }
    #third-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 29.88%;
    }
    #fourth-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 33.2142%;
    }
    #fifth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 36.31%;
    }
    #sixth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.3;
      top: 61.785%;
    }
    #seventh-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 64.5238%;
    }
  }
  .state-2 {
    div {
      transition: all 0.8s linear;
    }
    #first-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 0;
    }
    #second-strip {
      height: 1px;
      width: 100%;
      opacity: 0.3;
      top: 26.547%;
    }
    #third-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 35.595%;
    }
    #fourth-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 54.762%;
    }
    #fifth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 55.476%;
    }
    #sixth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.3;
      top: 83.333%;
    }
    #seventh-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 84.881%;
    }
  }
  .state-3 {
    div {
      transition: all 0.8s linear;
    }
    #first-strip {
      height: 1px;
      width: 100%;
      opacity: 0.3;
      top: 0;
    }
    #second-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 9.7619%;
    }
    #third-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 49.5238%;
    }
    #fourth-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 54.7619%;
    }
    #fifth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 61.9047%;
    }
    #sixth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.3;
      top: 77.0238%;
    }
    #seventh-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 84.8809%;
    }
  }
  .state-4 {
    div {
      transition: all 0.8s linear;
    }
    #first-strip {
      height: 1px;
      width: 100%;
      opacity: 0.3;
      top: 0;
    }
    #second-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 7.9762%;
    }
    #third-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 20.3571%;
    }
    #fourth-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 45%;
    }
    #fifth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 69.6428%;
    }
    #sixth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.3;
      top: 84.7619%;
    }
    #seventh-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 86.3095%;
    }
  }
  .state-5 {
    div {
      transition: all 0.8s linear;
    }
    #first-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 0;
    }
    #second-strip {
      height: 1px;
      width: 100%;
      opacity: 0.6;
      top: 7.0238%;
    }
    #third-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 55.8333%;
    }
    #fourth-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 57.3809%;
    }
    #fifth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 58.6904%;
    }
    #sixth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.3;
      top: 74.7619%;
    }
    #seventh-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 79.0476%;
    }
  }
  .state-6 {
    div {
      transition: all 0.8s linear;
    }
    #first-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 0%;
    }
    #second-strip {
      height: 1px;
      width: 50%;
      opacity: 0.6;
      top: 45.9524%;
    }
    #third-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 47.619%;
    }
    #fourth-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 66.5476%;
    }
    #fifth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 67.8571%;
    }
    #sixth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.3;
      top: 88.3333%;
    }
    #seventh-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 92.619%;
    }
  }
  .state-7 {
    div {
      transition: all 0.8s linear;
    }
    #first-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 0%;
    }
    #second-strip {
      height: 1px;
      width: 100%;
      opacity: 0.6;
      top: 12.619%;
    }
    #third-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 31.0714%;
    }
    #fourth-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 51.1904%;
    }
    #fifth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 52.619%;
    }
    #sixth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.3;
      top: 54.2857%;
    }
    #seventh-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 59.8809%;
    }
  }
  .state-8 {
    div {
      transition: all 0.8s linear;
    }
    #first-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 0%;
    }
    #second-strip {
      height: 1px;
      width: 100%;
      opacity: 0.6;
      top: 16.7857%;
    }
    #third-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 30.9523%;
    }
    #fourth-strip {
      height: 1px;
      width: 50%;
      opacity: 0.3;
      top: 33.0952%;
    }
    #fifth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.6;
      top: 35%;
    }
    #sixth-strip {
      height: 3px;
      width: 25%;
      opacity: 0.3;
      top: 37.1428%;
    }
    #seventh-strip {
      height: 1px;
      width: 25%;
      opacity: 0.3;
      top: 39.2857%;
    }
  }
}

.slider-wrapper-right {
  .numbers-enter-active,
  .numbers-leave-active,
  .second8-enter-active,
  .second8-leave-active {
    transition: all 0.8s linear;
  }

  .numbers-enter-from,
  .numbers-leave-to {
    opacity: 0;
  }
  .first8 {
    line-height: 1.56rem;
    transition: all linear 0.8s;
  }
  .first8.inactive {
    font-size: 0.625rem;
    line-height: 0.625rem;
    left: 1.8rem;
  }
  .second8-enter-from,
  .second8-leave-to {
    font-size: 0.625rem;
    line-height: 0.625rem;
    left: 3.6rem;
  }
  .third8 {
    transition: all linear 0.8s;
    opacity: 1;
  }
  .third8.inactive {
    opacity: 0;
  }
}

.slider-wrapper-left,
.slider-wrapper-right {
  .absolute {
    background: #97a3cb;
  }
}
.slider-wrapper-top {
  .menu {
    .menu-grad {
      div {
        border-radius: 50%;
        transform: scale(0);
        transition: all 0.15s linear;
      }
      .blue-b {
        position: absolute;
        width: 180.46px;
        height: 180.46px;
        left: -104px;
        top: 18px;

        background: linear-gradient(
          321.88deg,
          rgba(7, 25, 61, 0) 12.53%,
          #f22959 43.45%,
          #0085ff 60.5%
        );
        filter: blur(60px);
      }
      .blue-s {
        position: absolute;
        width: 112.05px;
        height: 112.05px;
        left: 44px;
        top: 22px;

        background: linear-gradient(
          209.3deg,
          rgba(0, 133, 255, 0) -2.55%,
          #0085ff 64.59%
        );
        filter: blur(60px);
        transform: rotate(165deg) scale(0);
      }
      .purple {
        position: absolute;
        width: 180.46px;
        height: 180.46px;
        left: -34px;
        top: 86px;

        background: linear-gradient(
          209.3deg,
          rgba(242, 137, 41, 0) -2.55%,
          #f22959 64.59%
        );
        opacity: 0.7;
        filter: blur(60px);
        transform: rotate(165deg) scale(0);
      }
      .purple-s {
        position: absolute;
        width: 180.46px;
        height: 180.46px;
        left: -70px;
        top: 47px;

        background: linear-gradient(
          321.88deg,
          rgba(7, 25, 61, 0) 12.53%,
          #f22959 43.45%,
          #0085ff 60.5%
        );
        filter: blur(60px);
      }
    }
    .menu-content {
      p {
        letter-spacing: 0.1rem;
      }
      * {
        transition: all 0.15s linear;
      }
    }
  }
  .menu.unactive {
    .menu-content:hover {
      p {
        letter-spacing: 0.3rem;
      }
      #second-menu-strip {
        width: 100%;
      }
    }
  }

  .connect {
    p,
    .plus,
    .plus div {
      transition: all 0.2s linear;
    }
    .plus {
      background: #ff2e53;
      div {
        background: white;
      }
    }
    .connect-grad {
      left: 3rem;
      top: -3rem;
      div {
        border-radius: 50%;
        transform: scale(0);
        transition: all 0.15s linear;
      }
      #grad-1 {
        position: absolute;
        width: 180.46px;
        height: 180.46px;
        left: 66px;
        top: -90px;

        background: linear-gradient(
          321.88deg,
          rgba(7, 25, 61, 0) 12.53%,
          #f22959 43.45%,
          #ff0000 60.5%
        );
        filter: blur(60px);
        z-index: 1;
      }
      #grad-2 {
        position: absolute;
        width: 112.05px;
        height: 112.05px;
        left: 203.59px;
        top: -86.41px;
        transform: rotate(165deg) scale(0);
        background: linear-gradient(209.3deg, #7b61ff -2.55%, #7b61ff 64.59%);
        filter: blur(60px);
        z-index: 2;
      }
      #grad-3 {
        position: absolute;
        width: 180.46px;
        height: 180.46px;
        left: 136.28px;
        top: -21.72px;
        transform: rotate(165deg) scale(0);
        background: linear-gradient(
          209.3deg,
          rgba(242, 137, 41, 0) -2.55%,
          #f22959 64.59%
        );
        opacity: 0.7;
        filter: blur(60px);
        z-index: 1;
      }
    }
  }
}
.slider-wrapper-bottom {
  svg {
    path {
      transition: all linear 0.3s;
      stroke: rgba(151, 163, 203, 0.6);
    }
  }
  p {
    transition: all linear 0.3s;
    color: rgba(151, 163, 203, 0.6);
  }
}
.slider-wrapper-bottom:hover {
  svg {
    path {
      transition: all linear 0.3s;
      stroke: white;
    }
  }
  p {
    transition: all linear 0.3s;
    color: white;
  }
}
.menu-label-enter-active,
.menu-label-leave-active {
  transition: all linear 0.075s;
}
.menu-label-enter-from,
.menu-label-leave-to {
  opacity: 0;
}
</style>
